var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "edit_svg__a",
    "data-svg-primary": "fill",
    d: "M3 14.706v2.364a.385.385 0 00.389.391h2.364a.365.365 0 00.272-.117l8.492-8.483-2.917-2.92-8.483 8.485a.382.382 0 00-.117.28zm13.773-8.1a.774.774 0 000-1.1l-1.82-1.82a.774.774 0 00-1.1 0l-1.42 1.423 2.916 2.916 1.423-1.423z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.350e31fc2ba8b32d65ca9cdc793af185.svg";